export const ANNOUNCEMENTS_PAGE_LIMIT = 20;
export const ANNOUNCEMENTS_MAX_OFFSET = 10_000;
export const ANNOUNCEMENTS_MAX_PAGE: number =
  Math.floor(ANNOUNCEMENTS_MAX_OFFSET / ANNOUNCEMENTS_PAGE_LIMIT) + 1;

export function normalizeAnnouncementsPage(page: number): number {
  return Number.isFinite(page)
    ? Math.max(1, Math.min(ANNOUNCEMENTS_MAX_PAGE, Math.floor(page)))
    : 1;
}

export function normalizeAnnouncementsSearchPage(value: unknown): number {
  return normalizeAnnouncementsPage(Number(value));
}

export function getAnnouncementsPageOffset(page: number): number {
  return (normalizeAnnouncementsPage(page) - 1) * ANNOUNCEMENTS_PAGE_LIMIT;
}

export function canMoveToNextAnnouncementsPage(
  page: number,
  itemCount: number,
): boolean {
  return (
    Number.isInteger(itemCount) &&
    itemCount >= ANNOUNCEMENTS_PAGE_LIMIT &&
    getAnnouncementsPageOffset(page) < ANNOUNCEMENTS_MAX_OFFSET
  );
}
